import type {ProcessorCapabilityStatusMeta} from '@/types';

import {
  getProductionStatus,
  PRODUCTION_STATUS_DISPLAY,
} from './productionStatus';

/** Overall production state, from the statuses the deploy writes. */
const ProductionStatusBadge = ({
  statuses,
}: {
  statuses?: ProcessorCapabilityStatusMeta;
}) => {
  const status = getProductionStatus(statuses);
  if (!status) {
    return <span className="text-slate-400">Unknown</span>;
  }
  const {label, className} = PRODUCTION_STATUS_DISPLAY[status];
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${className}`}>
      {label}
    </span>
  );
};

export default ProductionStatusBadge;
